import type { Collaborator } from "@nlc/shared-types";

import { isOwnerOrAdmin, UserRoleEnum } from "@nlc/shared-types";
import { useCallback } from "react";

import { useGetProjectCollaborators } from "@/features/request/shared/UseGetProjectCollaborators.tsx";
import { useUser } from "@/hooks/useUser";

// Mirrors RequestAuthorizationPolicyService.canChangeCollaborators
export function useCollaboratorPermissions(
  brandId: null | number | undefined,
): {
  canEdit: boolean;
  canManage: (collaborator: Collaborator) => boolean;
} {
  const { data: collaborators } = useGetProjectCollaborators();
  const { data: userData } = useUser();

  const roleId = userData?.user.roleId;
  const isCollaborator = roleId === UserRoleEnum.Collaborator;
  const actor = collaborators?.find(({ id }) => id === userData?.user.id);
  const canEdit =
    roleId !== undefined &&
    (!isCollaborator ||
      (brandId != null && !!actor?.brandIds.includes(brandId)));

  const canManage = useCallback(
    (collaborator: Collaborator) => {
      if (!canEdit) return false;
      if (!isCollaborator) return true;
      if (brandId == null) return false;

      return (
        isOwnerOrAdmin(collaborator.roleId) ||
        (collaborator.roleId === UserRoleEnum.Collaborator &&
          collaborator.brandIds.includes(brandId))
      );
    },
    [brandId, canEdit, isCollaborator],
  );

  return { canEdit, canManage };
}
